export default __webpack_public_path__ + "static/media/approch2.0b49bf83.webp";